export default {
  list: [
    {
      title: "ESSENTIALS",
      price: 49,
      priceRepaid: "",
      beforeText:
        "For individuals and teams who are ready to create together faster",
      afterText:
        "",
      advantages: [
        "Create unlimited interactive apps",
        "Up to 5GB of storage",
        "Scan and anchor unlimited spaces",
        "Instant content deployment",
        "Live Collaborative Editing",
        "Unity workflow compatible",
        "Drag and drop editor",
        "Access public and private asset libraries",
        "Automated Asset Pipeline",
      ],
      payPlan: {
        month: {
          price: "",
          plan: "",
          text: "",
          name: "",
          title: "",
          priceM: "",
        },
        prepaid: {
          price: "",
          plan: "",
          text: "",
          name: "",
          title: "",
          priceM: "",
        },
      },
    },
    {
      title: "STUDIO",
      price: 99,
      priceRepaid: "",
      beforeText:
        "For professionals and companies looking to accelerate development",
      afterText: "",
      advantages: [
        "Everything in Essentials",
        "Unlimited storage",
        "Access to multiplayer API",
        "Publish white labeled apps",
      ],
      payPlan: {
        month: {
          price: "",
          plan: "",
          text: "",
          name: "",
          title: "",
          priceM: "",
        },
        prepaid: {
          price: "",
          plan: "",
          text: "",
          name: "",
          title: "",
          priceM: "",
        },
      },
    },
    {
      title: "COMMERCIAL",
      price: "Customized pricing, please inquire",
      priceRepaid: "Customized Pricing",
      beforeText:
        "For organizations who lead innovation within their industry",
      afterText: "",
      advantages: [
        "Customized features and integrations to suit your enterprise needs",
        "Training and support",
        "Hardware discounts",
        "Source code",
        "Reseller licenses available",
      ],
    },
  ],
  step: "",
  accept: false,
  complete: false,
  publicKey: window.config.stripeKey,
  card: {
    cvc: "",
    number: "",
    expiry: "",
  },

  //elements
  cardNumber: "",
  cardExpiry: "",
  cardCvc: "",
  stripe: null,
  cardName: "",
  cardAddress: "",
  cardZip: "",
  cardCountry: "",
  cardCity: "",

  // errors
  stripeError: "",
  cardCvcError: "",
  cardExpiryError: "",
  cardNumberError: "",
  cardNameError: "",
  cardAddressError: "",
  cardZipError: "",
  cardCountryError: "",
  cardCityError: "",

  token: null,

  loading: false,

  // registration
  email: "",
  password: "",
  handle: "",
  license: "",
  agreedToEula: false,
  plan: "enklu-pro",
  errorText: false,
  customName: "",
  customEmail: "",
  customPhone: "",
  customRequest: "",
  desk: window.innerWidth > 1200,
  redirect: window.config.redirectUrl,
  hasLicense: window.config.hasLicense,
};